import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, Injector, Input, NgModule, OnChanges, ViewEncapsulation } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { WorkType } from '@jms/model';
import { PickerItemModule, PickerItemStyle } from '@jms/ui/ui.picker.item';
import { PickerBaseComponent, PickerFetch } from '@jms/ui/ui.pickers.base';
import { NgSelectModule } from '@ng-select/ng-select';
import { Observable, of } from 'rxjs';

@Component({
    selector: 'work-type-picker',
    templateUrl: './work.type.picker.component.html',
    styleUrls: ['./work.type.picker.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: WorkTypePickerComponent, multi: true }
    ],
    standalone: false
})
export class WorkTypePickerComponent extends PickerBaseComponent implements OnChanges {

  @Input() public data: WorkType[];
  @Input() public placeholder = '<Work Type>';
  @Input() public appendTo;
  @Input() public multiple: boolean;

  public data$: Observable<WorkType[]>;
  public PickerItemStyle = PickerItemStyle;

  constructor(
    injector: Injector,
    private http: HttpClient
  ) {
    super(injector);
  }

  public ngOnChanges() {

    this.data$ = this.fetch === PickerFetch.Automatic
      ? this.getWorkTypes()
      : of(this.data);

  }

  private getWorkTypes(): Observable<WorkType[]> {
    return this.http.get<WorkType[]>('/api/picker/work/types');
  }

}
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgSelectModule,
    PickerItemModule,
  ],
  declarations: [
    WorkTypePickerComponent
  ],
  providers: [],
  exports: [
    WorkTypePickerComponent
  ],
})
export class WorkTypePickerModule { }